import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }
    baseUrl = environment.baseUrl;
    xApiKey = environment.xApiKey;
    
  private _username: string;

  setUsername(username: string) {
    this._username = username;
  }

  getUsername(): string {
    return this._username;
  }

  checkPurchaserMaterialStatus(purchaserCode:string){
    return this.httpClient.get(this.baseUrl+`/check_purchaser_material_status?purchaserCode=${purchaserCode}`);
  }

}
